import styled from 'styled-components';
import { primaryColorLight, primaryColorWeak, blueGray } from '../../config/colors';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';

export const ArrowsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-end;
`;

export const ArrowUp = styled(IoIosArrowUp).attrs((props) => ({
  size: 16,
}))`
  color: ${blueGray};
`;

export const ArrowDown = styled(IoIosArrowDown).attrs((props) => ({
  size: 16,
}))`
  color: ${blueGray};
`;

export const stylesByDesign = {
  container: (styles) => ({
    ...styles,
    width: '100%',
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: 0,
    paddingRight: '0.5rem',
    fontSize: '0.875rem',
  }),
  singleValue: (styles) => ({
    ...styles,
  }),
  control: (styles) => ({
    ...styles,
    padding: '5px 10px',
    ':hover': {
      cursor: 'pointer',
    },
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    fontSize: '0.875rem',
    backgroundColor: isSelected && primaryColorLight,
    ':hover': {
      backgroundColor: !isSelected && primaryColorWeak,
      cursor: 'pointer',
    },
    whiteSpace: 'nowrap',
  }),
  menu: (styles) => ({
    ...styles,
    width: '200%',
  }),
};
